import React, { Fragment } from 'react';

// React Bootstrap
import { Row, Col } from 'react-bootstrap';

// Packages
import PropTypes from 'prop-types';

// Utils
import { epochToLocalDate } from '../../../utils/dateConverter';
import formatString from '../../../utils/formatString';

const JobData = (props) => {
	const { jobData } = props;

	const parseData = (key, data) => {
		let jobData = data;

		if (jobData === null) {
			jobData = 'Null'
		}
		else if (typeof jobData !== 'string') {
			if (typeof jobData === 'number') {
				if (key === 'timestamp') jobData = epochToLocalDate(jobData);
			}
			else if (typeof jobData === 'boolean') {
				if (jobData) {
					jobData = 'True';
				}
				else {
					jobData = 'False';
				}
			}
		}

		return jobData;
	}

	const renderValue = (key, value, depth = 0) => {
		const indentStyle = { marginLeft: `${depth * 20}px` };

		if (value === null || value === undefined) {
			return <p className='m-0' style={indentStyle}><b>{formatString(key)}:</b> {parseData(key, value)}</p>;
		}

		if (Array.isArray(value)) {
			return (
				<Fragment>
					<p className='m-0' style={indentStyle}><b>{formatString(key)}:</b></p>
					{value.map((item, index) => (
						<div key={index} style={{ marginLeft: `${(depth + 1) * 20}px` }}>
							{typeof item === 'object' && item !== null ? (
								<Fragment>
									<p className='m-0'><b>[{index}]:</b></p>
									{Object.keys(item).map((subKey, subIdx) => (
										<div key={subIdx}>
											{renderValue(subKey, item[subKey], depth + 2)}
										</div>
									))}
								</Fragment>
							) : (
								<p className='m-0'><b>[{index}]:</b> {parseData(`${key}[${index}]`, item)}</p>
							)}
						</div>
					))}
				</Fragment>
			);
		}

		if (typeof value === 'object') {
			return (
				<Fragment>
					<p className='m-0' style={indentStyle}><b>{formatString(key)}:</b></p>
					<div style={{ marginLeft: `${(depth + 1) * 20}px` }}>
						{Object.keys(value).map((subKey, subIdx) => (
							<div key={subIdx}>
								{renderValue(subKey, value[subKey], depth + 1)}
							</div>
						))}
					</div>
				</Fragment>
			);
		}

		return <p className='m-0' style={indentStyle}><b>{formatString(key)}:</b> {parseData(key, value)}</p>;
	}

	return (
		<Fragment>
			<Row>
				<h5>Data</h5>
				<Col>
					{Object.keys(jobData).map((key, idx) => (
						<Fragment key={idx}>
							{renderValue(key, jobData[key])}
						</Fragment>
					))}
				</Col>
				{/* <Col>
					<pre style={{ 
						backgroundColor: '#f8f9fa', 
						padding: '15px', 
						borderRadius: '5px',
						fontSize: '14px',
						lineHeight: '1.4',
						whiteSpace: 'pre-wrap',
						wordWrap: 'break-word'
					}}>
						{JSON.stringify(jobData, null, 2)}
					</pre>
				</Col> */}
			</Row>
		</Fragment>
	)
}

JobData.propTypes = {
	jobData: PropTypes.object.isRequired
}

export default JobData;
